import Collection, {ModelInterface} from "./collection";

// const debug = "StackFILO"
const debug = false


// FILO (First In, Last Out)

export default class StackFILO<Model extends ModelInterface> extends Collection<Model> {

    protected stackSize: number = 100

    // VERY IMPORTANT IT SHOULD add to the begginign
    add(model:Model) {
        this.models.unshift(model)
        this.byId[model.id] = model

        this.removeBottomElements()
    }

    reset(models?:Model[]) {
        this.models    = []
        this.byId      = {}

        _.map(models, model=>{
            this.models.push(model)
            this.byId[model.id] = model
        })

        this.removeBottomElements()
    }

    removeBottomElements() {

        debug && console.log(debug, "removeBottomElements() stackSize=", this.stackSize)

        if (this.models.length>=this.stackSize) {
            this.models = this.models.slice(0,this.stackSize)

            // we need to regenerate map
            this.byId = {}

            _.map(this.models, (model)=>{
                this.byId[model.id] = model
            })
        }

        debug && this.debugIds()

    }

    debugIds() {
        console.log("--------")
        _.map(this.models,(model)=>{
            console.log(model.id)
        })
        console.log("=========")
    }

}
